import { default as en_US } from './langs/en';
import { default as th_TH } from './langs/th';

const TRANSLATIONS = {
  'en': en_US,
  'th': th_TH
};

export default TRANSLATIONS;
